import { render } from "./LeadingText.vue?vue&type=template&id=7830ff6e"
import script from "./LeadingText.vue?vue&type=script&lang=js"
export * from "./LeadingText.vue?vue&type=script&lang=js"
script.render = render

export default script